export default __webpack_public_path__ + "static/media/menBluze.b1b7f146.svg";